var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 103,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 51.5a51.5 51.5 0 1 1-103 0 51.5 51.5 0 0 1 103 0M77.943 31.994a4.827 4.827 0 0 0-6.952.142L48.633 60.622 35.16 47.142a4.829 4.829 0 0 0-6.823 6.824l17.033 17.04a4.83 4.83 0 0 0 6.946-.13l25.699-32.122a4.83 4.83 0 0 0-.064-6.76z"
  })));
};
export default SvgSuccess;